// importing images
import GameImage from "../images/game.png";
import ConverterImage from "../images/converter.png";

// The "Homepage component will just be the landing page of the app nothing special lol."
const Homepage = () => {
  return (
    <div className="homepage">
      <p>Click the dropdown to select an option.</p>
      <div className="images">
        <div>
          <h3 style={{ textAlign: "center" }}>Converter</h3>
          <img src={ConverterImage} alt="" />
        </div>
        <div>
          <h3 style={{ textAlign: "center" }}>Game</h3>
          <img src={GameImage} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Homepage;
